import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "MIKRONU PRECIZITĀTE",
    desc: "Diagnostika ar dīleru līmeņa iekārtām. Nolasām kļūdas, dzīvos datus un pierādām problēmu, nevis minam.",
    img: "https://images.unsplash.com/photo-1702146713870-8cdd7ab983fb?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    num: "02",
    title: "METINĀŠANA UN VIRSBŪVE",
    desc: "Virsbūves, rāmja un izplūdes sistēmas metināšana — argona un pusautomāta darbi ar tīrām, izturīgām šuvēm.",
    img: "https://images.unsplash.com/photo-1563229708-55d0a600b01d?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    num: "03",
    title: "GODĪGI MATERIĀLI",
    desc: "Oriģinālas vai OEM detaļas, sertificēti šķidrumi un rakstiska garantija 12 mēnešus katram veiktajam darbam.",
    img: "https://images.unsplash.com/photo-1696494561430-de087dd0bd69?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const Manifesto = ({ content }) => (
  <section id="par-mums" className="relative overflow-hidden py-24 sm:py-36">
    <div className="mx-auto max-w-[1500px] px-5 sm:px-10">
      <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="lg:sticky lg:top-32 lg:self-start">
          <SectionLabel num="/ 03">Manifests</SectionLabel>
          <Reveal>
            <h2 className="mt-6 font-head text-4xl font-extrabold uppercase italic leading-[0.92] tracking-tight sm:text-5xl lg:text-6xl">
              <span className="metal-text">{content.about_title}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">{content.about_text}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 inline-flex items-center gap-4 border border-white/10 bg-white/[0.03] px-5 py-4">
              <span className="font-head text-4xl font-extrabold crimson-text">12</span>
              <span className="font-mono-t text-[10px] uppercase leading-tight tracking-[0.2em] text-slate-400">
                mēnešu
                <br />
                garantija
              </span>
            </div>
          </Reveal>
        </div>

        <div className="space-y-5">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08}>
              <motion.article
                whileHover={{ x: 8 }}
                transition={{ type: "spring", stiffness: 200, damping: 22 }}
                data-testid={`manifesto-chapter-${c.num}`}
                className="group relative grid gap-5 overflow-hidden border border-white/10 bg-[#0e0e13] p-5 sm:grid-cols-[150px_1fr] sm:p-7"
              >
                <div className="relative h-32 overflow-hidden sm:h-full">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                  />
                  <div className="absolute inset-0 bg-rose-900/25 mix-blend-multiply" />
                </div>
                <div>
                  <div className="font-mono-t text-[11px] tracking-[0.3em] text-rose-500">{c.num}</div>
                  <h3 className="mt-2 font-head text-2xl font-bold uppercase tracking-tight text-slate-100 sm:text-3xl">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.desc}</p>
                </div>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-rose-600 transition-all duration-700 group-hover:w-full" />
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
